import { defineEntity, object, string } from '~/prix'

const studentCompanyEad = defineEntity({
  key: 'alunoEmpresa',
  title: 'EAD de aluno empresa',
  sources: ['oltp'],
  entitySchema: 'ead',
  schema: object({
    cpf: string(),
    cnpj: string(),
    dataInclusao: string(),
    dataModificacao: string(),
  }),
})

export default studentCompanyEad
